<template>
  <div>
    <vue-spinner v-if="loading.summaryIndex"></vue-spinner>
    <div v-else>
      <router-link :to="{name:'Report Summary', params: {reportid: this.$route.params.reportid}}" tag="button" class="btn green">
        Add Summary
      </router-link>

      <div v-for="summary in summaryIndex">
        <hr>
        <p>{{summary.name}}</p>
        <vue-good-table
            v-if="summary.rows.length > 0"
            :columns="applySortFunctions(summary.columns, summary.id, summary.rows.length)"
            :rows="summary.rows"
            :sort-options="{
                initialSortBy: {field: summary.initial_sort, type: 'asc'}
            }"
            :id="'summary-table'+summary.id"
        >

        </vue-good-table>
        <br>
        <router-link :to="{name:'Report Summary', params: {reportid: reportId, summaryId: summary.id}}" tag="button" class="btn green pull-right">
          Edit
        </router-link>
        <button class="btn default pull-right delete-summary" @click="showDeleteSummaryModal(summary.id)">Delete</button>
        <div class="clearfix"></div>

      </div>
    </div>

    <div id="summary-delete-modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">DELETE REPORT SUMMARY</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <p>Are you sure you would like to delete this summary?</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green" @click.prevent="deleteSummaryConfirm">Yes</button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner';
  import {mapActions, mapGetters} from "vuex";
  import {HTTP, ERROR} from "@/http-common";

  export default {
    data() {
      return {
        activeTab: 'summary',
        reportId: null,
        selectedSummaryId: null
      }
    },
    components: {
      'breadcrumb-bar': Breadcrumbs,
      'vue-spinner': Spinner
    },
    mounted() {
      if (!this.$route.params.reportid) {
        this.$notify({type: 'error', text: 'Wrong report.'});
        this.$route.push({'name': 'Reports Index'})
      }

      this.reportId = this.$route.params.reportid;
      this.fetchSummaryIndex({reportId: this.reportId, sort: {}});

      $('#summary-delete-modal').on('hidden.bs.modal', () => {
        this.selectedSummaryId = null;
      })
    },
    methods: {
      ...mapActions([
        'fetchSummaryIndex'
      ]),
      showDeleteSummaryModal(summaryId) {
        this.selectedSummaryId = summaryId;
        $('#summary-delete-modal').modal('show');
      },
      deleteSummaryConfirm() {
        HTTP.post('report-summary/delete', {
          summary_id: this.selectedSummaryId
        }).then(response => {
          ERROR(response);
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          $('#summary-delete-modal').modal('hide');
          this.fetchSummaryIndex({reportId: this.reportId});
        })
      },
      applySortFunctions(columns, summaryId, totalRows) {
        return columns.map(col => {
          col.summaryId = summaryId;
          col.totalRows = totalRows;
          if (col.field.includes('date')) {
            col.sortFn = this.onSortDate;
            return col;
          }

          if (col.field.includes('currency')) {
            col.sortFn = this.onSortCurrency;
            return col;
          }

          if (col.field.includes('number') || col.field.includes('__unduplicated') || col.field.includes('__total')) {
            col.sortFn = this.onSortNumber;
            return col;
          }

          col.sortFn = this.onSortDefault;
          return col;
        });
      },
      onSortDate(x, y, col, rowX, rowY) {
        if (rowX.originalIndex == (col.totalRows - 1)) {
          return;
        }

        let xDate = moment(x).unix();
        let yDate = moment(y).unix();
        return (xDate < yDate ? -1 : (xDate > yDate ? 1 : 0));
      },
      onSortCurrency(x, y, col, rowX, rowY) {
        if (rowX.originalIndex == (col.totalRows - 1)) {
          return;
        }
        x = parseInt(x.replace(/\D/g, ''));
        y = parseInt(y.replace(/\D/g, ''));

        return (x < y ? -1 : (x > y ? 1 : 0))
      },
      onSortNumber(x, y, col, rowX, rowY) {
        if (rowX.originalIndex == (col.totalRows - 1)) {
          return;
        }
        return (x < y ? -1 : (x > y ? 1 : 0))
      },
      onSortDefault(x, y, col, rowX, rowY) {
        if (rowX.originalIndex == (col.totalRows - 1)) {
          return;
        }
        return (x < y ? -1 : (x > y ? 1 : 0))
      },
    },
    computed: {
      ...mapGetters({
        'loading': 'getReportsLoading',
        'summaryIndex': 'getReportSummaryIndex'
      }),
    },
  }
</script>

<style scoped>
  .delete-summary {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// ReportSummary.vue?054f8c00